import React from 'react';
import classnames from 'classnames';
import styles from './Button.module.scss';

/**
 * @type {React.FC<any>}
 * @deprecated
 */
const Button = ({
  className = null,
  children = null,
  buttonStyle = '',
  size = 'large',
  ...props
}) => {
  let style = classnames(styles.root, styles[buttonStyle], styles[size], className);
  return (
    <button className={style} {...props}>
      {children}
    </button>
  );
};

export { Button };
